import React from "react";
import "./LoadingComponent.css";
// import { Spinner } from "react-bootstrap";
const LoadingComponent = () => {
  // return (
  //   <div className="d-flex justify-content-center loading-div">
  //     <div
  //       className="spinner-border text-primary mt-md-3 "
  //       role="status"
  //       style={{ width: "3rem", height: "3rem" }}
  //     >
  //       <span className="sr-only">Loading...</span>
  //     </div>
  //   </div>
  // );

  return (
    <div className="timeline-wrapper">
      <div className="timeline-item">
        <div className="animated-background">
          <div className="background-masker header-top"></div>
          <div className="background-masker header-left"></div>
          <div className="background-masker header-right"></div>
          <div className="background-masker header-bottom"></div>
          <div className="background-masker subheader-left"></div>
          <div className="background-masker subheader-right"></div>
          <div className="background-masker subheader-bottom"></div>
          <div className="background-masker content-top"></div>
          <div className="background-masker content-first-end"></div>
          <div className="background-masker content-second-line"></div>
          <div className="background-masker content-second-end"></div>
          <div className="background-masker content-third-line"></div>
          <div className="background-masker content-third-end"></div>
        </div>
      </div>
    </div>
    // <div className='d-flex justify-content-center'>
    //   <Spinner animation="grow" variant="primary" />
    //   <Spinner animation="grow" variant="primary" />
    //   <Spinner animation="grow" variant="primary" />
    // </div>
  );
};

// const LoadingComponent = () => {
//   return <div className="nb-spinner" />;
// };

export default LoadingComponent;
